var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 25H56.6667V15C56.6667 13.6739 56.1399 12.4021 55.2022 11.4645C54.2645 10.5268 52.9927 10 51.6667 10H11.6667C10.3406 10 9.06881 10.5268 8.13113 11.4645C7.19345 12.4021 6.66666 13.6739 6.66666 15V55C6.66813 55.4703 6.80225 55.9307 7.05361 56.3283C7.30497 56.7258 7.66337 57.0444 8.08764 57.2474C8.51192 57.4504 8.98485 57.5296 9.45211 57.4758C9.91938 57.4221 10.362 57.2377 10.7292 56.9437L21.6667 48.125V57.5C21.6667 58.8261 22.1934 60.0979 23.1311 61.0355C24.0688 61.9732 25.3406 62.5 26.6667 62.5H55.9135L67.6042 71.9437C68.0465 72.3016 68.5977 72.4978 69.1667 72.5C69.8297 72.5 70.4656 72.2366 70.9344 71.7678C71.4033 71.2989 71.6667 70.663 71.6667 70V30C71.6667 28.6739 71.1399 27.4021 70.2022 26.4645C69.2645 25.5268 67.9927 25 66.6667 25ZM19.9635 43.0563L11.6667 49.7656V15H51.6667V42.5H21.5354C20.9632 42.5001 20.4084 42.6964 19.9635 43.0563ZM66.6667 64.7656L58.3698 58.0563C57.9274 57.6984 57.3762 57.5022 56.8073 57.5H26.6667V47.5H51.6667C52.9927 47.5 54.2645 46.9732 55.2022 46.0355C56.1399 45.0979 56.6667 43.8261 56.6667 42.5V30H66.6667V64.7656Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllMessagesIcon);
export default __webpack_public_path__ + "static/media/all-messages-icon.3503ef573eff2a892c4aa991f3550ef2.svg";
export { ForwardRef as ReactComponent };